import React from 'react';
import { ArrowUpIcon, AtSignIcon, PaperclipIcon, PlusIcon, SearchIcon, SlidersHorizontalIcon, XIcon } from 'lucide-react';
import { pencilComments } from '../../../data/pencilCanvas';
export function CommentPin({
  x,
  y,
  style
}: {
  x: number;
  y: number;
  style?: React.CSSProperties;
}) {
  return <div className="absolute" style={{
    left: x,
    top: y,
    ...style
  }} data-id="element-228" data-mp="2jazwvu93sf7g">
      <div className="grid h-10 w-10 place-items-center rounded-full rounded-bl-[4px] bg-[#292929] shadow-[0_4px_10px_rgba(18,19,20,0.25)]" data-id="element-229" data-mp="2jdvutikyb3vw">
        <PlusIcon size={18} className="text-white" strokeWidth={2.5} data-id="element-230" data-mp="2sb6adg4sxf6m" />
      </div>
    </div>;
}
interface ComposerProps {
  x: number;
  y: number;
  text: string;
  caretOn: boolean;
  style?: React.CSSProperties;
}

/** Dark on-canvas composer: empty state → typed state, send flips grey → Pencil yellow. */
export function Composer({
  x,
  y,
  text,
  caretOn,
  style
}: ComposerProps) {
  const filled = text.length > 0;
  const caret = <span className="ml-px inline-block h-[15px] w-[1.5px] translate-y-[3px] bg-white" style={{
    opacity: caretOn ? 1 : 0
  }} data-id="element-231" data-mp="3c21j2fb7rb0h" />;
  return <div className="absolute flex gap-2" style={{
    left: x,
    top: y,
    transformOrigin: 'top left',
    ...style
  }} data-id="element-232" data-mp="2f6k50dq7msy1">
      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full rounded-bl-[4px] bg-[#292929]" data-id="element-233" data-mp="2k5dkgbp24u0u">
        <span className="grid h-8 w-8 place-items-center rounded-full bg-white text-[12px] font-medium text-[#191915]" data-id="element-234" data-mp="2p59mw6i3wdea">GT</span>
      </div>
      <div className="w-[260px] overflow-hidden rounded-xl bg-[#292929] shadow-[0_4px_8px_rgba(18,19,20,0.12)]" data-id="element-235" data-mp="2u3ui1rii46vv">
        {filled ? <>
            <p className="min-h-[60px] px-4 pt-2 text-[12px] leading-[18px] text-white" data-id="element-236" data-mp="32w4qb39u62ah">
              {text}
              {caret}
            </p>
            <div className="my-1 h-px bg-[#3D3D3D]" data-id="element-237" data-mp="37upv7g019a59" />
            <div className="flex h-9 items-center justify-between pb-1.5 pl-4 pr-1.5" data-id="element-238" data-mp="3cvdibql556u7">
              <span className="flex items-center gap-2 text-white" data-id="element-239" data-mp="3ht5it8zuq1a0">
                <AtSignIcon size={14} data-id="element-240" data-mp="3hrax3sgra54v" />
                <PaperclipIcon size={14} data-id="element-241" data-mp="2s4qegr8emjs4" />
              </span>
              <span className="grid h-7 w-7 place-items-center rounded-full bg-[#FFF310]" data-id="element-242" data-mp="2s36yz2ukocre">
                <ArrowUpIcon size={14} className="text-ink" strokeWidth={2.5} data-id="element-243" data-mp="2n4lu2q4dl4wm" />
              </span>
            </div>
          </> : <div className="flex h-10 items-center justify-between pl-4 pr-1.5" data-id="element-244" data-mp="2x4co6qp0xhw6">
            <span className="flex items-center text-[13px] text-[#707070]" data-id="element-245" data-mp="3avrab6e89z7g">
              {caret}
              <span className="ml-1" data-id="element-246" data-mp="35x6i9u94qlu3">Add a comment</span>
            </span>
            <span className="grid h-7 w-7 place-items-center rounded-full bg-[#707070]" data-id="element-247" data-mp="35zale9z7fgtb">
              <ArrowUpIcon size={14} className="text-[#B8B8B8]" strokeWidth={2.5} data-id="element-248" data-mp="3ks4cytrr3nec" />
            </span>
          </div>}
      </div>
    </div>;
}
export function CommentSidebar({
  style
}: {
  style?: React.CSSProperties;
}) {
  return <div className="absolute right-3 top-[71px] z-20 flex h-[757px] w-[284px] flex-col overflow-hidden rounded-xl border border-[#E0E0E0] bg-white shadow-[0_4px_8px_rgba(18,19,20,0.04)]" style={style} data-id="element-249" data-mp="1lhmeahfn2xlc">
      <div className="border-b border-[#EBEBEB] px-4 py-2" data-id="element-250" data-mp="5x3pdpi9h5r0">
        <div className="flex h-4 items-center justify-between" data-id="element-251" data-mp="3nen01hxuzu9j">
          <span className="text-[11px] font-semibold tracking-[0.1px] text-[#191915]" data-id="element-252" data-mp="3ned65j9p12yk">Comments</span>
          <XIcon size={16} className="text-ink" data-id="element-253" data-mp="3sbvjdluqu4cd" />
        </div>
        <div className="mt-2 flex gap-2" data-id="element-254" data-mp="3ecvse7jrddd1">
          <div className="flex h-7 flex-1 items-center gap-1.5 rounded border border-[#E0E0E0] px-2" data-id="element-255" data-mp="3eg1jttfv0rbx">
            <SearchIcon size={14} className="text-[#707070]" data-id="element-256" data-mp="3idfr3fjzcp1a" />
            <span className="text-[12px] text-[#707070]" data-id="element-257" data-mp="34h2hstplntxw">Search</span>
          </div>
          <span className="grid h-7 w-[26px] place-items-center rounded border border-[#E0E0E0]" data-id="element-258" data-mp="39e2ggjk4duez">
            <SlidersHorizontalIcon size={14} className="text-ink" data-id="element-259" data-mp="12o4h6bpkzx2e" />
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-3 px-2 pb-1 pt-2" data-id="element-260" data-mp="17mfrenjsg9l5">
        {pencilComments.map(row => <div key={row.name} className="relative flex gap-2 rounded py-2 pl-2 pr-1" data-id="element-261" data-mp="33pc74emihqlk">
            <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full border border-white bg-[#E0E0E0] text-[11px] font-medium text-[#191915]" data-id="element-262" data-mp="2yralpn1m5f6x">
              {row.initials}
            </span>
            <div className="min-w-0 flex-1" data-id="element-263" data-mp="2ppt0xrd9gpbw">
              <div className="flex items-center gap-1 text-[12px] leading-[18px]" data-id="element-264" data-mp="2pt72ixe3ouia">
                <span className="font-medium text-[#191915]" data-id="element-265" data-mp="2kt2l955dbvr0">{row.name}</span>
                <span className="text-[#707070]" data-id="element-266" data-mp="2g09gwidtapfg">{row.time}</span>
              </div>
              <p className="mt-1 text-[12px] leading-[18px] text-[#707070]" data-id="element-267" data-mp="2b2ztt9dwapus">{row.text}</p>
            </div>
            <span className="w-6 shrink-0" data-id="element-268" data-mp="271ed1cy8prfb">
              {row.unread && <span className="ml-auto mr-1 mt-[6px] block h-1.5 w-1.5 rounded-full bg-ink" data-id="element-269" data-mp="2210c0ev23hqs" />}
            </span>
          </div>)}
      </div>
    </div>;
}